import { render, staticRenderFns } from "./drawRecord.vue?vue&type=template&id=7052de18&scoped=true&"
import script from "./drawRecord.vue?vue&type=script&lang=js&"
export * from "./drawRecord.vue?vue&type=script&lang=js&"
import style0 from "./drawRecord.vue?vue&type=style&index=0&id=7052de18&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7052de18",
  null
  
)

export default component.exports